//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "APACHE_two",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6:'',
        value7: "",
        value8: "",
        value9: "",
        value10: "",
        value12: "",
        value13: "",
       
        value15: "",
      },
      form1:{
        value1:'0',
        value14: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: "≤44" },
        { value: "2", name: "45~54" },
        { value: "3", name: "55~64" },
        { value: "5", name: "65~74" },
        { value: "6", name: "≥75" },
      ],
      dataList1: [
        { value: "0", name: "36~38.4" },
        { value: "1", name: "34~35.9/38.5~38.9" },
        { value: "2", name: "32~33.9" },
        { value: "3", name: "30~31.9/39~40.9" },
        { value: "3.0", name: "≤29.9/≥41" },
      ],
      dataList2: [
        { value: "0", name: "70~109" },
        { value: "2", name: "110~139/55~59" },
        { value: "3", name: "140~179/40~54" },
        { value: "4", name: "≥180/≤39" },
      ],
      dataList3: [
        { value: "0", name: "12~24" },
        { value: "1", name: "10~11/25~34" },
        { value: "2", name: "6~9" },
        { value: "3", name: "35~49" },
        { value: "4", name: "≥50/≤5" },
      ],
      dataList4: [
        { value: "0", name: "70~109" },
        { value: "1", name: "50~69/110~129" },
        { value: "3", name: "130~159" },
        { value: "4", name: "≤49/≥160" },
      ],
      dataList5: [
        { value: "0", name: "7.33~7.49" },
        { value: "1", name: "7.5~7.59" },
        { value: "2", name: "7.25~7.32" },
        { value: "3", name: "7.6~7.69/7.15~7.24" },
        { value: "4", name: "≥7.7/＜7.15" },
      ],
      dataList6: [
        { value: "0", name: "130~149" },
        { value: "1", name: "150~154" },
        { value: "2", name: "155~159/120~129" },
        { value: "3", name: "160~179/111~119" },
        { value: "4", name: "≥180/≤110" },
      ],
      dataList7: [
        { value: "0", name: "3.5~5.4" },
        { value: "1", name: "5.5~5.9/3~3.4" },
        { value: "2", name: "2.5~2.9" },
        { value: "3", name: "6~6.9" },
        { value: "4", name: "≥7.0/＜2.5" },
      ],
      dataList8: [
        { value: "0", name: "0.6~1.4" },
        { value: "2", name: "＜0.6/1.5~1.9" },
        { value: "3", name: "2~3.4" },
        { value: "4", name: "≥3.5" },
      ],
      dataList9: [
        { value: "4", name: "＞=500" },
        { value: "3", name: "350~499" },
        { value: "2", name: "200~349" },
        { value: "0", name: "＜200或PaO₂＞70" },
        { value: "1", name: "PaO₂ 61-70" },
        { value: "3", name: "PaO₂ 55-60" },
        { value: "4", name: "PaO₂＜55" },
      ],
      dataList10: [
        { value: "0", name: "＞70" },
        { value: "1", name: "61~70" },
        { value: "3", name: "55~60" },
        { value: "4", name: "＜55" },
      ],
      dataList11: [
        { value: "0", name: "30~45.9" },
        { value: "1", name: "46~49.9" },
        { value: "2", name: "50~59.9/20~29.9" },
        { value: "4", name: "＜20/≥60" },
      ],
      dataList12: [
        { value: "0", name: "3~14.9" },
        { value: "1", name: "15~19.9" },
        { value: "2", name: "1~2.9/20~39.9" },
        { value: "4", name: "＜1/≥40" },
      ],
      dataList13: [
        { value: "2", name: "是，且为择期手术转入" },
        { value: "5", name: "是，且未手术治疗" },
        { value: "5.0", name: "是，且为急诊术后转入" },
        { value: "0", name: "否" },
      ],
      dataList14: [
        { value: "2", name: "是，且为择期手术转入" },
        { value: "5", name: "是，且未手术治疗" },
        { value: "5", name: "是，且为急诊术后转入" },
        { value: "0", name: "否" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let form1 = JSON.parse(JSON.stringify(self.form1));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      for (const key in form1) {
        if (form1.hasOwnProperty(key)) {
          if (!form1[key]) {
            flag = false;
          } else {
            form1[key] = Number(form1[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        result += form1.value1 ? form.value9 : 0
        result += 15 - form1.value14
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/APACHE_two.vue